import React, { useEffect } from 'react';
import { SimpleDialog, FormGrid } from '../../primitives';
import { FormControlsForFields } from '../../schemed';
import { ContactOrgLinkControl } from './ContactOrgLinkControl';
import { ContactsListData } from '../data/useContactsList';
import { Schema } from '../../../hooks/useSchema';
import { CRMGeoSuggestionsKeys, useCRMGeoContext } from '../CRMGeoContext';
import { AutoSuggestMultiple } from '../../primitives/AutoSuggests';
import { ContactTags } from './ContactTags';
import { Divider, Typography } from '@mui/material';
import { useCRMContext } from '../CRMContext';

interface Props {
  data: ContactsListData["newRecord"];
  schema: Schema;
}

export const CreateContactDialog = (props: Props) => {
  const { data } = props;

  const geoCtx = useCRMGeoContext();
  const ctx = useCRMContext();

  useEffect(() => {
    if(data.dialog.isOpen) {
      geoCtx.ensureLoaded();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.dialog.isOpen]);
  
  return (
    <SimpleDialog
      {...data.dialog}
      dialogTitle="Новый контакт"
      save={() => data.save()}
      maxWidth="md"
      noFullscreen
      submitOnModEnter
    >
      {!!data.item &&
      <FormGrid columns="1fr max-content 1fr max-content 1fr" forceEvenColumns>
        <FormGrid columns="1fr" noMargin>
          <Typography
            variant="caption"
            color="textSecondary"
            sx={{ display: "block", borderBottom: "0.5px dotted currentColor", opacity: 0.75 }}>
            1. Имя и контакты
          </Typography>

          <FormControlsForFields
            fields={[
              ["last_name", { controlProps: { autoFocus: true }}],
              ["first_name"],
              ["middle_name"],
              ["email"],
              ["phone"],
            ]}
            schema={props.schema}
            data={data.item}
            onChange={(o,c) => data.update(c)}
            errors={data.errors}
          />

        </FormGrid>

        <Divider orientation="vertical" sx={{ color: "primary.main"}} />

        <FormGrid columns="1fr" noMargin>
          <Typography
            variant="caption"
            color="textSecondary"
            sx={{ display: "block", borderBottom: "0.5px dotted currentColor", opacity: 0.75 }}>
            2. География и описание
          </Typography>

          <FormControlsForFields
            fields={[
              ["geo_country", { control: AutoSuggestMultiple, suggestionsKey: CRMGeoSuggestionsKeys.countries }],
              ["geo_city", { control: AutoSuggestMultiple, suggestionsKey: CRMGeoSuggestionsKeys.cities }],
              ["description"],
            ]}
            schema={props.schema}
            data={data.item}
            onChange={(o,c) => data.update(c)}
          />

        </FormGrid>

        
        <Divider orientation="vertical" />


        <FormGrid columns="1fr" noMargin>

          <Typography
            variant="caption"
            color="textSecondary"
            sx={{ display: "block", borderBottom: "0.5px dotted currentColor", opacity: 0.75 }}>
            3. Компания и теги
          </Typography>

          <ContactOrgLinkControl
            value={data.item.organization_link}
            onChange={v => data.update({ organization_link: v })}
            hideIsActive
            noAutoFocus
            />

          {!!ctx.settings.contact_categories?.length && <>
            <FormControlsForFields
                fields={[
                  ["categories", { autoComplete: true }],
                ]}
                schema={props.schema}
                data={data.item}
                onChange={(o,c) => data.update(c)}
              />
            </>}

          <div style={{ height: 8 }} />
          
          <ContactTags
            tagIds={data.item.tags}
            onUpdateTags={(newTagIds) => data.update({ tags: newTagIds.map(Number) })}
            />

          
        </FormGrid>
      </FormGrid>}
    </SimpleDialog>
  );
}
